// 순수(비-React) 모듈에서도 import되므로 vanilla 엔트리를 사용한다.
// top-level 'jotai'는 jotai/react(React.createContext)를 끌어와 비-React 테스트 환경에서 깨짐.
import { atom } from 'jotai/vanilla';
import { atomFamily } from 'jotai/vanilla/utils';
import type { LaboratoryStorageData } from '../../../native-module';

/**
 * 실험실 설정값 atom (앱 전역, 키별 단일 인스턴스).
 *
 * native 훅(`useLaboratorySetting.ts`)과 비-React 접근(`getDefaultStore` 기반 헬퍼)이
 * 동일한 atom 인스턴스를 공유하기 위해 플랫폼 중립 모듈로 분리한다.
 * (`.web` 변형이 없어 web/native 모두 같은 파일로 resolve 됨)
 */
export const laboratorySettingAtomFamily = atomFamily(
  (_key: keyof LaboratoryStorageData) => atom<boolean | undefined>(undefined),
);

// iOS `UserDefaultsHandler.swift` 의 기본값과 동일하게 유지
export const LABORATORY_DEFAULT_VALUES: Record<
  keyof LaboratoryStorageData,
  boolean
> = {
  IS_TOUCH_VIBRATION: false,
  IS_LIKE_FOLDER: true,
  IS_GIF_IMAGE: true,
  IS_SELECT_GOODS_SCREEN_SHOT_SHARE: true,
  IS_HOME_LIVE_PREVIEW: true,
};
